import React, { useEffect, useMemo } from 'react';

import { MatchedEmployee } from '@/modules/employer/components/Lockbox/lockbox.types';
import { MatchingListWrapper } from '@/modules/employer/components/Lockbox/LockboxDetails/components/LockboxInfo/LockboxMatchingList';
import { useEmployeeCardsList } from '@/modules/employer/components/Lockbox/LockboxDetails/hooks';
import useLockboxDetailsStore from '@/modules/employer/components/Lockbox/LockboxDetails/stores/useLockboxDetails.store';
import useGetMatchedEmployeeByIdQuery from '@/modules/employer/components/Lockbox/queries/useGetMatchedEmployeeById.query';

import EmployeesList from './components/EmployeesList';
import { getMatchedEmployeeById } from './getMatchedEmployeeById';

const ViewSelectedEmployee = () => {
  const { originalLockbox, setEditableLockbox } = useLockboxDetailsStore();

  const employeeFromMatchEmployees = useMemo(() => getMatchedEmployeeById(originalLockbox?.employeeId, originalLockbox?.accountId, originalLockbox?.matchEmployees),
    [originalLockbox]);

  const { foundEmployee } = useGetMatchedEmployeeByIdQuery({
    employeeId: originalLockbox?.employeeId,
    accountId: originalLockbox?.accountId,
    enabled: !employeeFromMatchEmployees,
  });

  const employeeOptions = useMemo(() => [employeeFromMatchEmployees || foundEmployee].filter(Boolean) as MatchedEmployee[],
    [employeeFromMatchEmployees, foundEmployee]);

  const employee = useMemo(() => employeeOptions?.[0], [employeeOptions]);

  const { fields } = useEmployeeCardsList({
    matchedEmployees: employeeOptions,
    lockboxType: originalLockbox?.lockboxType,
  });

  useEffect(() => {
    setEditableLockbox({
      employeeId: employee?.employeeId,
      employeeAccountStatus: employee?.accountStatus,
      employeeInvestmentsBalance: employee?.investmentsBalance,
      employeeAvailableAmount: employee?.availableAmount,
    });
  }, [employee, setEditableLockbox]);
  
  if (!employeeFromMatchEmployees && !foundEmployee) {
    return null;
  }

  return (
    <MatchingListWrapper title="Employee" childrenWrapperProps={{ pad: 'spacing12' }}>
      <EmployeesList fields={fields} />
    </MatchingListWrapper>
  );
};

export default ViewSelectedEmployee;
